import React, { useState } from "react";
import { Modal } from 'react-bootstrap';

function DeleteModal(props) {
    // console.log(props)
    const [state, setState] = useState(false);
    const [message, setMessage] = useState("");

    const deleteUser = () => {
        setState(false);
        setMessage(""); 
        props.deleteUser(props.user._id)
        .then(result => {
            if (result.error && result.error !== null) {
                setState(true);
                setMessage(result.error.message);       
            } else {
                props.closeDeleteModal()
            }
        })
    }
    return (
        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={props.show}
            className="t-modal delete-modal"
            onHide={props.closeDeleteModal}
        >
            <Modal.Header>
                <button className="close-btn" onClick={props.closeDeleteModal}>×</button>
                <Modal.Title id="contained-modal-title-vcenter">
                    <img className="ms-3 mb-1" src="/icons/trash.png" alt="delete" width="30" />
                    حذف
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-3 px-4 mt-3">
                <h4>ﻫﻞ أﻧﺖ ﻣﺘﺄﻛﺪ ﻣﻦ رﻏﺒﺘﻚ ﻣﻦ ﺣﺬف ﺑﻴﺎﻧﺎت "{props.user && props.user !== null && props.user.name}" ﻧﻬﺎﺋﻴﺎً ﻣﻦ السجل  </h4>
                <div className="alert alert-danger text-center mb-5 fs-5" role="alert" style={{display: state ? "block" : "none"}}>
                    {message}
                </div>
                <button className="px-4 py-2 mx-2 my-4 red-btn" onClick={deleteUser}>حذف</button>
            </Modal.Body>
        </Modal>
    );
}

export default DeleteModal;